import { render, staticRenderFns } from "./registeredEnterprise.vue?vue&type=template&id=5668bd6f&scoped=true&"
import script from "./registeredEnterprise.vue?vue&type=script&lang=js&"
export * from "./registeredEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./registeredEnterprise.vue?vue&type=style&index=0&id=5668bd6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5668bd6f",
  null
  
)

export default component.exports